import { createFileRoute } from '@tanstack/react-router'

import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { documentListFilters } from '@/components/Internal/Documents/document-list-filters'
import { DocumentsView } from '@/components/Internal/Documents/DocumentsView'
import { useProjectDetail } from '@/components/Internal/Projects/project-detail-context'

export const Route = createFileRoute('/internal/projects/$id/documents')({
  validateSearch: listSearchValidator(documentListFilters),
  component: ProjectDocumentsScreen,
})

function ProjectDocumentsScreen() {
  const { project } = useProjectDetail()
  const filters = useListFilters(documentListFilters, Route)

  return (
    <DocumentsView
      projectId={project.id}
      customerUnsubscribed={project.customerEmailUnsubscribed === true}
      filters={filters}
    />
  )
}
